<template>
  <b-card no-body class="rounded-xl border-none mt-2">
    <modal :show.sync="isActiveLocal" size="lg" header-classes="bg-primary p-3">
      <h6
        slot="header"
        class="modal-title uppercase text-white font-semibold pt-1"
      >
        Recipients
      </h6>
      <div>
        <b-form-group class="mt-6">
          <b-form-radio
            v-model="schedule"
            class="custom-control-inline radio-btn-fix"
            name="some-radios"
            value="A"
            ><p class="font-semibold">Send Immediately</p></b-form-radio
          >
          <b-form-radio
            v-model="schedule"
            class="custom-control-inline radio-btn-fix"
            name="some-radios"
            value="B"
            ><p class="font-semibold">Send to Groups</p></b-form-radio
          >
        </b-form-group>

        <div v-show="schedule === 'A'">
          <base-button
            type="primary"
            class="mb-4 float-right"
            @click="isActiveLocal = false"
            >Import</base-button
          >
          <b-input-group>
            <b-form-input
              class="border-none shadow-lg"
              type="text"
              min="0.00"
              placeholder="Enter Search...."
            ></b-form-input>

            <b-input-group-append>
              <b-button
                variant="white"
                class="flex items-center shadow-lg"
                aria-label="search"
              >
                <feather-icon
                  class="cursor-pointer mr-2"
                  icon="SearchIcon"
                  svgClasses="w-4 h-4"
                ></feather-icon>
              </b-button>
            </b-input-group-append>
          </b-input-group>

          <SendIndividuallyTable />
        </div>

        <div v-show="schedule === 'B'">
          <base-button
            type="primary"
            class="mb-4 float-right"
            @click="isActiveLocal = false"
            >Import</base-button
          >
          <b-input-group class="">
            <b-form-input
              class="border-none shadow-lg"
              type="text"
              min="0.00"
              placeholder="Enter Search...."
            ></b-form-input>

            <b-input-group-append>
              <b-button
                variant="white"
                class="flex items-center shadow-lg"
                aria-label="search"
              >
                <feather-icon
                  class="cursor-pointer mr-2"
                  icon="SearchIcon"
                  svgClasses="w-4 h-4"
                ></feather-icon>
              </b-button>
            </b-input-group-append>
          </b-input-group>

          <SendGroupTable />
        </div>
      </div>
    </modal>
  </b-card>
</template>
<script>
import SendIndividuallyTable from "./SendIndividuallyTable";
import SendGroupTable from "./SendGroupTable";
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { schedule: "A" };
  },
  components: {
    SendIndividuallyTable,
    SendGroupTable,
  },
  computed: {
    isActiveLocal: {
      get() {
        return this.isActive;
      },
      set(val) {
        if (!val) {
          this.closeModal();
        }
      },
    },
  },
};
</script>
<style>
.vs-input--placeholder {
  left: 5px !important;
  top: 4px !important;
}
.caption-textbox {
  background: #f4f5f6;

  border-radius: 6px;
}
.line-h30 {
  line-height: 30px;
}
.bck-btn-css {
  background: #f4f5f6;
  width: 10%;
  border-radius: 3px;
  padding: 2px 0px;
}
.popup-width800 > .vs-popup {
  width: 800px !important;
}
.vs-table--tbody-table th {
  background: #f4f5f6 !important;
}
.text-muted-g {
  color: #626262;
}
</style>
